import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { ExpireDateFirstVariant } from '@shared/models';
import { DaysLeftPipe, SafePipe, VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant1',
  styleUrl: './variant1.component.scss',
  templateUrl: './variant1.component.html',
  imports: [DatePipe, SafePipe, DaysLeftPipe, VariableReplacementPipe],
})
export class Variant1Component extends BaseComponent {
  campaignEndDate = input.required<string>();
  config = input.required<ExpireDateFirstVariant>();
}
